import { resolveNoContent, resolveWithBody } from "./Utils/utils";

export default {
    init(promiseRequest) {
        return {
            getListing(eventId) {
                return promiseRequest({
                    url: `/api/admin/events/${eventId}/live-streams`,
                    method: "get",
                    json: true,
                }).then(resolveWithBody());
            },

            createLiveStream(eventId, matId, vendor, metadata) {
                return promiseRequest({
                    url: `/api/admin/events/${eventId}/live-streams`,
                    method: "post",
                    json: {
                        eventId: eventId,
                        matId: matId,
                        vendor: vendor,
                        metadata: metadata,
                    },
                }).then(resolveNoContent());
            },
            deleteLiveStream(eventId, liveStreamId) {
                return promiseRequest({
                    method: "delete",
                    url: `/api/admin/events/${eventId}/live-streams/${liveStreamId}`,
                    json: true,
                }).then(resolveNoContent());
            },
        };
    },
};
